"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../utils");
var _photographyClientLib = require("@wix/photography-client-lib");
var FullscreenCheckoutLink = /*#__PURE__*/function (_React$Component) {
  function FullscreenCheckoutLink() {
    return _React$Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(FullscreenCheckoutLink, _React$Component);
  var _proto = FullscreenCheckoutLink.prototype;
  _proto.getLinkText = function getLinkText(count) {
    return _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UOU_Continue_Checkout_Label') + (" (" + count + ")");
  };
  _proto.render = function render() {
    var _this$props = this.props,
      _onClick = _this$props.onClick,
      cartItemsCount = _this$props.cartItemsCount;
    return cartItemsCount ? /*#__PURE__*/_react["default"].createElement("button", {
      className: "pro-fullscreen-checkout-link",
      onClick: function onClick() {
        return _onClick();
      },
      tabIndex: _utils.utils.getTabIndex('fullscreenCheckout'),
      "aria-label": this.getLinkText(cartItemsCount)
    }, this.getLinkText(cartItemsCount)) : null;
  };
  return FullscreenCheckoutLink;
}(_react["default"].Component);
var _default = exports["default"] = FullscreenCheckoutLink;